import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import DeployLegalFooter from "../../components/deploy/DeployLegalFooter";

/**
 * RD-0793 — Customer-facing limitations (authoritative detail: docs/deploy/limitations.md).
 */
function DeployLimitationsPage() {
  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployLimitationsPage] mount`);
  }, []);

  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployLimitationsPage] render`);
  });

  return (
    <>
      <SEO
        title="Limelite Deploy — Limitations"
        description="What RivieraDeploy does not guarantee: third parties, AI assistive features, security actions, and support expectations. EUR billing."
        keywords="Limelite Deploy, limitations, SLA, AWS, MCP"
        url="/limelite/deploy/limitations"
      />
      <div className="bg-black text-silver-light min-h-[calc(100vh-4rem)] px-4 py-12">
        <div className="max-w-3xl mx-auto space-y-8">
          <p className="text-sm uppercase tracking-widest text-lime-500 text-xs uppercase tracking-widest">Limelite Deploy</p>
          <h1 className="text-3xl font-serif font-medium">Product limitations</h1>
          <p className="text-silver-medium text-sm">
            This page sets expectations for the deploy service. Long-form reference:{" "}
            <code className="text-gray-500">docs/deploy/limitations.md</code> in the product repository.
          </p>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Third parties</h2>
            <p>
              Git hosts, AWS, and Stripe can experience outages or limits. Deploys require reachable repos and valid AWS
              capacity in <span className="text-silver-light">eu-north-1</span> unless documented otherwise.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">AI-assisted features</h2>
            <p>
              Analysis and diagnostics are assistive. When the AI path is unavailable, MCP tools may return{" "}
              <span className="text-silver-light">meta.ai_degraded</span> with heuristic results. Infrastructure steps use
              deterministic templates where applicable — AI is not the sole gate for standard provisioning.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Security &amp; abuse</h2>
            <p>
              We may rate-limit, suspend, or stop resources per policy and billing state. See{" "}
              <Link to="/limelite/deploy/terms" className="text-silver-light underline underline-offset-2">
                Terms
              </Link>{" "}
              and the abuse reporting flow.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Support &amp; SLA</h2>
            <p>
              Self-serve beta does not imply a specific SLA unless a separate agreement says otherwise. Billing is in{" "}
              <span className="text-silver-light">EUR</span>.
            </p>
          </section>

          <p className="text-sm">
            <Link to="/limelite/deploy" className="text-silver-light underline underline-offset-2">
              ← Back to Limelite Deploy
            </Link>
          </p>

          <DeployLegalFooter className="mt-10" />
        </div>
      </div>
    </>
  );
}

export default DeployLimitationsPage;
